import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-icon-circle-check-bold',
    templateUrl: './icon-circle-check-bold.component.html',
    styleUrls: ['./icon-circle-check-bold.component.css'],
    standalone: true,
})
export class IconCircleCheckBoldComponent {
  @Input() color = '#047857;';
  @Input() width = '24';
  @Input() height = '24';
}
